import React, {FC} from 'react';
import {secondsPer} from 'components/ContentPagesComponents/Charts/timing';
import {Markdown} from 'components/Markdown';
import {motion} from 'framer-motion';
import {useIsMobile} from 'hooks/useIsMobile';

import * as styles from './styles.module.scss';

type ChartBarChartProps = {
    bars: string
    description: string
}

const ChartBarChart: FC<ChartBarChartProps> = ({bars, description}) => {
	const mobile = useIsMobile();

	const heights = bars.split(',').map((v) => Math.min(
		Math.max(Number(v) || 0, 0), 100,
	));

	// Set up a container with variants that stagger for us
	const containerProps = {
		className: styles.chart,
		initial: 'hidden',
		whileInView: 'show',
		viewport: {once: !mobile},

		variants: {
			show: {
				transition: {
					delayChildren: secondsPer(heights.length) / 2,
					staggerChildren: secondsPer(heights.length),
				}
			}
		}
	};

	// Create start and end color heights for our bars
	const itemProps = (height: number) => ({
		className: styles.item,
		variants: {
			hidden: {
				height: '0%',
			},
			show: {
				height: `${height}%`,
			},
		},
	});

	return (
		<div className={styles.wrapper}>
			<motion.div {...containerProps}>
				{heights.map((height, index) => (
					<motion.div {...itemProps(height)} key={index} />
				))}
			</motion.div>
			<div>
				<Markdown markdown={description} />
			</div>
		</div>
	);
};

export default ChartBarChart;
